export const enrichIntentModel = (intentData) => {
  return intentData.intents.map((intent) => {
    return {
      ...intent,
      selected: false,
      noBeh: false,
      noPn: false,
      override: false,
      threshold: 0,
      advancedOpen: false,
      type: 'intent',
    };
  });
};

export const enrichEnrichmentModel = (enrichmentData) => {
  const enrichments = [];
  enrichmentData.forEach((enrichment) => {
    enrichment.values.forEach((value) => {
      enrichments.push({
        selected: false,
        group: enrichment.name,
        name: value.value,
        id: `${enrichment.name}>${value.value}`,
        noPn: false,
        override: false,
        threshold: 0,
        advancedOpen: false,
        type: 'enrichment',
        signals: [{ str: 50 }],
      });
    });
  });

  return enrichments;
};

export const intentTagStrength = {
  Antimatter: 0,
  Tangential: 5,
  Weak: 25,
  Normal: 50,
  Strong: 75,
  Strongest: 100,
  Boost: 1000,
};
